@let _isDevice = isDevice();

@if (!_isDevice) {
  <div class="c__tiles-wrapper" [ngClass]="{'is-small': tileSize < 3}" data-testid="wrapper">
    <div class="c__content-left">
      @if (tilesGroup.tiles[0]) {
        <sd-tile [tile]="tilesGroup.tiles[0]"
          [tilePosition]="position"
          [titleLevel]="tileTitleLevel"
          [twicPicsAutoSize]="twicPicsAutoSize"
          (openModal)="onOpenModal(tilesGroup.tiles[0], $event)"
        />
      }
    </div>
    <div class="c__content-right">
      @if (tilesGroup.tiles[1]) {
        <sd-tile
          [tilePosition]="position === positionEnum.left ? positionEnum.right : positionEnum.left"
          [titleLevel]="tileTitleLevel"
          [tile]="tilesGroup.tiles[1]"
          [twicPicsAutoSize]="twicPicsAutoSize"
          (openModal)="onOpenModal(tilesGroup.tiles[1], $event)"
        />
      }
      @if (tilesGroup.tiles[2]) {
        <sd-tile
          [tilePosition]="position === positionEnum.left ? positionEnum.right : positionEnum.left"
          [titleLevel]="tileTitleLevel"
          [tile]="tilesGroup.tiles[2]"
          [twicPicsAutoSize]="twicPicsAutoSize"
          (openModal)="onOpenModal(tilesGroup.tiles[2], $event)"
        />
      }
    </div>
  </div>
} @else {
  <sd-slider
    [customConfig]="tilesSliderConfig"
    [itemTemplate]="tilesTpl"
    [size]="sizesEnum.l"
    [items]="tilesGroup.tiles"
    [context]="context"
  />
}

<ng-template let-tile #tilesTpl>
  <sd-tile
    [tile]="tile"
    [tilePosition]="position"
    [titleLevel]="tileTitleLevel"
    [twicPicsAutoSize]="(tilesGroup.tiles.indexOf(tile) + 1) > 1 ? true : twicPicsAutoSize"
    (openModal)="onOpenModal(tile, $event)"
  />
</ng-template>

@if (tilesGroup?.footnote && !_isDevice) {
  <p class="is-caption" data-testid="caption">
    {{tilesGroup?.footnote}}
  </p>
}

<sd-tile-modal
  [(isOpened)]="isOpened"
  [tileTitleLevel]="tileTitleLevel"
  [tileModal]="modalContent"
  (videoPlayed)="onVideoPlayed($event)"
  (videoEnded)="onVideoEnded($event)"
  (isOpenedChange)="onOpenChange($event)"
/>
